import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-white border-b border-primary-200" }
const _hoisted_2 = { class: "max-w-screen-xl px-4 py-3 mx-auto" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-accent-600 rounded-lg flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-5 h-5 text-white",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-heading font-semibold text-primary-800 hidden sm:block" }, " Foxwood Crossing ", -1)
const _hoisted_6 = { class: "hidden md:flex items-center gap-1" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Proposals ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Events ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Covenants ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Contact ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Manager ")
const _hoisted_12 = { class: "flex items-center gap-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:inline" }, "Pay Dues", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5 13l4 4L19 7"
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:inline" }, "Dues Paid", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Log in ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Sign Up ")
const _hoisted_19 = { class: "w-8 h-8 bg-primary-200 rounded-full flex items-center justify-center" }
const _hoisted_20 = { class: "text-xs font-medium text-primary-700" }
const _hoisted_21 = { class: "text-left" }
const _hoisted_22 = { class: "font-medium text-primary-800 leading-tight" }
const _hoisted_23 = { class: "text-xs text-primary-500 leading-tight" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
  })
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open menu", -1)
const _hoisted_27 = {
  key: 0,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16M4 18h16"
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 0,
  class: "md:hidden border-t border-primary-100 bg-white"
}
const _hoisted_34 = { class: "px-4 py-3 space-y-1" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Pay Dues ")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5 13l4 4L19 7"
  })
], -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Dues Paid ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Proposals ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Events ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Covenants ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Contact ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Manager ")

import { useAuthStore } from "@/stores/auth";
import { computed, ref } from "vue";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const auth = useAuthStore();
const mobileMenu = ref(false);

const signedIn = computed(() => auth.loggedIn);
const isStaff = computed(() => auth.is_staff);
const userName = computed(
  () => auth.user_details.first_name + " " + auth.user_details.last_name
);
const initials = computed(
  () =>
    (auth.user_details.first_name?.[0] || "") +
    (auth.user_details.last_name?.[0] || "")
);
const house = computed(
  () =>
    auth.user_details.house.house_number + " " + auth.user_details.house.street
);
const hasPaid = computed(() => auth.hasPaidCurrentYear);

const logout = async () => {
  localStorage.clear();
  await auth.logout();
  router.push({ name: "login" });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: _unref(signedIn) ? '/community' : '/',
          class: "flex items-center gap-2 hover:opacity-90 transition-opacity"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("nav", _hoisted_6, [
          (_unref(signedIn))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/proposals",
                class: "px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-900 hover:bg-primary-50 rounded-lg transition-colors"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: "/events",
            class: "px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-900 hover:bg-primary-50 rounded-lg transition-colors"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/hoa",
            class: "px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-900 hover:bg-primary-50 rounded-lg transition-colors"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-900 hover:bg-primary-50 rounded-lg transition-colors"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          (_unref(isStaff))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/manager",
                class: "px-4 py-2 text-sm font-medium text-accent-600 hover:text-accent-700 hover:bg-accent-50 rounded-lg transition-colors"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_unref(signedIn) && !_unref(hasPaid))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/payments",
                class: "px-4 py-2 text-sm font-medium text-white bg-accent-600 hover:bg-accent-700 rounded-lg transition-colors flex items-center gap-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(signedIn) && _unref(hasPaid))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/payments",
                class: "px-4 py-2 text-sm font-medium text-green-700 bg-green-100 hover:bg-green-200 rounded-lg transition-colors flex items-center gap-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _hoisted_16
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_unref(signedIn))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-900 transition-colors"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/register",
                  class: "px-4 py-2 text-sm font-medium text-white bg-accent-600 hover:bg-accent-700 rounded-lg transition-colors"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_component_router_link, {
                  to: "/profile",
                  class: "hidden sm:flex items-center gap-2 px-3 py-2 text-sm text-primary-700 hover:bg-primary-50 rounded-lg transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(initials)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(userName)), 1),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(house)), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  onClick: logout,
                  class: "p-2 text-primary-500 hover:text-primary-700 hover:bg-primary-50 rounded-lg transition-colors",
                  title: "Logout"
                }, _hoisted_25)
              ], 64)),
          _createElementVNode("button", {
            class: "md:hidden p-2 text-primary-600 hover:bg-primary-50 rounded-lg transition-colors",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenu.value = !mobileMenu.value))
          }, [
            _hoisted_26,
            (!mobileMenu.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_27, _hoisted_29))
              : (_openBlock(), _createElementBlock("svg", _hoisted_30, _hoisted_32))
          ])
        ])
      ])
    ]),
    (mobileMenu.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("nav", _hoisted_34, [
            (_unref(signedIn) && !_unref(hasPaid))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/payments",
                  class: "block px-4 py-2 text-white bg-accent-600 hover:bg-accent-700 rounded-lg transition-colors font-medium",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileMenu.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(signedIn) && _unref(hasPaid))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/payments",
                  class: "block px-4 py-2 text-green-700 bg-green-100 hover:bg-green-200 rounded-lg transition-colors font-medium flex items-center gap-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileMenu.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_36,
                    _hoisted_37
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(signedIn))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: "/proposals",
                  class: "block px-4 py-2 text-primary-600 hover:bg-primary-50 rounded-lg transition-colors",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (mobileMenu.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_38
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: "/events",
              class: "block px-4 py-2 text-primary-600 hover:bg-primary-50 rounded-lg transition-colors",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (mobileMenu.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_39
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/hoa",
              class: "block px-4 py-2 text-primary-600 hover:bg-primary-50 rounded-lg transition-colors",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (mobileMenu.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "block px-4 py-2 text-primary-600 hover:bg-primary-50 rounded-lg transition-colors",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (mobileMenu.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_41
              ]),
              _: 1
            }),
            (_unref(isStaff))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: "/manager",
                  class: "block px-4 py-2 text-accent-600 hover:bg-accent-50 rounded-lg transition-colors font-medium",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (mobileMenu.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_42
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})